export enum NewsletterEndpoint {
  Base = '/documents/newsletter',
  Send = '/send',
  Content = '/content',
  Type = '/type',
}
